module.exports = __webpack_public_path__ + "static/media/image_lime@2x-min.e740cab3.jpg";